import { GridLayout, Box } from '@wishket/design-system';
import { twJoin } from 'tailwind-merge';

import { PersonalDataHeader, Fortune, Grass } from '@/widgets/NewLanding';

const PersonalDataBox = () => {
  return (
    <GridLayout>
      <Box
        className={twJoin(
          'grid-in-content',
          'flex flex-col gap-6 rounded-3xl border border-gray-100 bg-white pt-5',
          'tablet:gap-5 desktop:gap-6 desktop:pt-6',
          'mt-8 desktop:mt-[60px]'
        )}
      >
        <PersonalDataHeader />
        <Box
          className={twJoin(
            'flex flex-col gap-6 rounded-3xl bg-w-bluegray-10 p-5',
            'tablet:flex-row tablet:gap-5 desktop:gap-8 desktop:p-8'
          )}
        >
          <Fortune />
          <Grass />
        </Box>
      </Box>
    </GridLayout>
  );
};

export default PersonalDataBox;
